import {
  ADD_PROPERTY_TYPE_API,
  PROPERTY_TYPE_LISTING,
  PROPERTY_DETAILS_API,
  SAVE_PROPERTY_TYPE,
  PROPERTY_TYPE_STATUS,
  PROPERTY_TYPE_SET_AMAKEN_NATIVE,
  AMENITIES_LIST,
  SAVE_AMENITIES,
  EDIT_PROPERTY_TYPE,
  PROPERTY_TYPE_INFO,
  PROPERTY_TYPE_MAPPINGS,
  SETTINGS_PROPERTY_TYPES,
} from "../constants/paths";
import { axios } from "./axios";

// ADD PROPERTY TYPE API
export const AddPropertyTypeApi = async (data) => {
  const response = await axios.post(ADD_PROPERTY_TYPE_API, data);
  return response?.data;
};

// PROPERTY TYPE LISTING API

export const propertyTypeListingApi = async (params) => {
  const response = await axios.get(PROPERTY_TYPE_LISTING, { params });
  return response;
};

// PROPERTY TYPE LISTING API
export const propertyDetailsApi = async (id) => {
  const response = await axios.get(`${PROPERTY_DETAILS_API}/${id}`);
  return response?.data;
};

// SAVE PROPERTY TYPE CONFIG API
export const savePropertyTypesApi = async (id, data) => {
  const response = await axios.put(`${SAVE_PROPERTY_TYPE}/${id}`, data);
  return response?.data;
};

// SAVE PROPERTY TYPE API
export const saveAmenitiesApi = async (id, data) => {
  const response = await axios.post(`${SAVE_AMENITIES}/${id}`, data);
  return response?.data;
};

// UPDATE PROPERTY TYPE STATUS
export const updatePropertyTypeStatus = async (id, data) => {
  const response = await axios.put(`${PROPERTY_TYPE_STATUS}/${id}`, data);
  return response?.data;
};

// SET PROPERTY TYPE AMAKEN NATIVE FLAG
export const updatePropertyTypeAmakenNativeApi = async (id, value) => {
  const response = await axios.put(
    `${PROPERTY_TYPE_SET_AMAKEN_NATIVE}/${id}/set-amaken-native`,
    null,
    {
      params: {
        value,
      },
    }
  );
  return response?.data;
};

// AMENITY LIST API
export const amenityListApi = async (params = {}) => {
  const defaultParams = {
    page: 0,
    size: 10,
    search: "",
    full: true,
    ...params,
  };
  const response = await axios.get(AMENITIES_LIST, { params: defaultParams });
  return response?.data;
};

// EDIT PROPERTY TYPE API
export const editPropertyTypeApi = async (data) => {
  const response = await axios.put(EDIT_PROPERTY_TYPE, data);
  return response?.data;
};

// EDIT PROPERTY TYPE API
export const fetchPropertyTypeInfo = async () => {
  const response = await axios.get(PROPERTY_TYPE_INFO);
  return response?.data;
};

// PROPERTY TYPE MAPPINGS LIST API
export const fetchPropertyTypeMappingsApi = async () => {
  const response = await axios.get(PROPERTY_TYPE_MAPPINGS);
  return response?.data;
};

// CREATE/UPDATE PROPERTY TYPE MAPPING API
export const savePropertyTypeMappingApi = async (data) => {
  const response = await axios.post(PROPERTY_TYPE_MAPPINGS, data);
  return response?.data;
};

// DELETE PROPERTY TYPE MAPPING API
export const deletePropertyTypeMappingApi = async (id) => {
  const response = await axios.delete(`${PROPERTY_TYPE_MAPPINGS}/${id}`);
  return response?.data;
};

// SETTINGS PROPERTY TYPES API (for source/target dropdowns)
export const fetchSettingsPropertyTypesApi = async () => {
  const response = await axios.get(SETTINGS_PROPERTY_TYPES);
  return response?.data;
};
